module.exports = __webpack_public_path__ + "static/media/greenManure.dc3f55d9.jpg";